import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { TrackPickedUpOrder } from '@durma-soft/gros-sdk';

import { CardDescription } from '@/components/shared/shadcn-ui/card';

interface TrackPickedUpOrdersListProps {
  orders: TrackPickedUpOrder[];
}

export const TrackPickedUpOrdersList = ({
  orders,
}: TrackPickedUpOrdersListProps) => {
  const { t } = useTranslation();

  if (orders.length === 0) return null;

  return (
    <div className="flex flex-col gap-2">
      <CardDescription className="xl:text-xl">
        {t('track.errors.order-already-picked-up.picked-up')}
      </CardDescription>
      <ul className="space-y-1.5 xl:space-y-2.5">
        {orders.map(({ id, food, shift, is_substitute, picked_up_at }) => (
          <li key={id} className="flex flex-wrap items-baseline gap-x-2">
            <span className="font-semibold text-2xl xl:text-4xl">
              {food.name}
            </span>
            <span className="text-muted-foreground text-base xl:text-xl">
              {shift}. {t('menu.shift').toLowerCase()}
              {picked_up_at && ` · ${format(new Date(picked_up_at), 'HH:mm')}`}
              {is_substitute &&
                ` · ${t('track.errors.order-already-picked-up.substitute-label')}`}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
